import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const CompanySpecificTrainingDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsCompanySpecificTrainingDetails" */ 'modules/activityDetails/CompanySpecificTrainingDetails/pages/CompanySpecificTrainingDetails'
    )
)

const CompanySpecificTrainingDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route
        exact
        path={`${routes.root}/:companySpecificTrainingId`}
        component={CompanySpecificTrainingDetails}
      />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default CompanySpecificTrainingDetailsRouting
